<template>
  <el-table
    class="k-promos-list"
    :data="promos"
    style="width: 100%"
    :row-class-name="tableRowClassName"
  >
    <!-- <el-table-column label="Активна" width="100">
      <template slot-scope="scope">
        <el-tooltip :content="'Акция ' + value" placement="top">
          <el-switch
            v-model="value"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="true"
            inactive-value="false"
            @change="handleChangeActiveStatus()"
          >
          </el-switch>
        </el-tooltip>
      </template>
    </el-table-column> -->

    <el-table-column
      class="k-promos-list__value"
      prop="_id"
      label="id"
      width="180"
    >
    </el-table-column>

    <el-table-column
      class="k-promos-list__value"
      prop="name"
      label="Название"
    >
    </el-table-column>

    <el-table-column
      class="k-promos-list__value"
      prop="description"
      label="Описание"
    >
    </el-table-column>

    <el-table-column
      class="k-promos-list__value"
      prop="foundation.title"
      label="Фонд"
    >
    </el-table-column>

    <el-table-column
      class="k-promos-list__value"
      label="Начало"
      width="140"
    >
      <template slot-scope="scope">
        {{formatDate(scope.row.startDate)}}
      </template>
    </el-table-column>

    <el-table-column
      class="k-promos-list__value"
      label="Конец"
      width="140"
    >
      <template slot-scope="scope">
        {{formatDate(scope.row.endDate)}}
      </template>
    </el-table-column>

   <el-table-column label="Action" width="100">
      <template slot-scope="scope">
        <el-tooltip content="Редактировать" placement="top">
          <el-button @click="handleEdit(scope.row)" type="success" icon="el-icon-edit" circle size="mini"></el-button>
        </el-tooltip>
        <el-tooltip content="Удалить" placement="top">
          <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
/**
 * Component: k-promos-list - Отображает список точек карты

*
* @version 1.0.0
*/


import formatDate from '@/util/formatDate';

export default {
  name: 'k-promos-list',

  props: {
    // Массив всех точек
    promos: {
      type: Array,
    },
  },

  methods: {
    // Класс для стрки, используется для расскарски строк таблицы в разные цвета
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
      return '';
    },

    // Редактирование точки
    handleEdit(data) {
      this.$emit('edit', data._id)
    },

    // Удаление точки
    handleDelete(data) {
      console.log('handleDelete');
      this.$emit('delete', data._id)
    },

    // Форматирование даты
    formatDate,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-promos-lis {
  $this: &;

  &__value {
    font-size: 10px;
  }
}
</style>
